import { render, staticRenderFns } from "./departmentVideo.vue?vue&type=template&id=c855f2ea&scoped=true"
import script from "./departmentVideo.vue?vue&type=script&lang=js"
export * from "./departmentVideo.vue?vue&type=script&lang=js"
import style0 from "./departmentVideo.vue?vue&type=style&index=0&id=c855f2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c855f2ea",
  null
  
)

export default component.exports